import {Dispatch} from "redux";
import { MixesAPI } from "../services/api/Api";
import {IMix} from "../constants/types";

const GET_RANDOM_MIX_START = 'Mixer/GET_RANDOM_MIX_START';
const GET_RANDOM_MIX_SUCCESS = 'Mixer/GET_RANDOM_MIX_SUCCESS';

interface IMixerState {
    isLoading: boolean,
    randomMix: IMix | null
}

interface IMixerAction {
    type: string,
    payload: IMix
}

const initialState: IMixerState = {
    isLoading: false,
    randomMix: null
};

const setRandomMix = (res: IMix) => ({
    type: GET_RANDOM_MIX_SUCCESS,
    payload: res
});

export const getRandomMix = () => (dispatch: Dispatch)=> {
    dispatch({type: GET_RANDOM_MIX_START});
    MixesAPI.getOneRandomMix()
        .then(res => dispatch(setRandomMix(res)))
        .catch(e => console.log(e))
};

export const updateRandomMix = (id: number, isMixLiked: boolean) => {
    return async () => {
        if (isMixLiked) {
             await MixesAPI.unlikeMix(id);
        } else {
            await MixesAPI.likeMix(id);
        }
    }
};

const MixerReducer = (state = initialState, action: IMixerAction): IMixerState => {

    switch (action.type) {

        case GET_RANDOM_MIX_START:
            return {
                ...state,
                isLoading: true
            };

        case GET_RANDOM_MIX_SUCCESS:
            return {
                ...state,
                randomMix: action.payload,
                isLoading: false
            };

        default:
            return state;
    }
};

export default MixerReducer;
